/* RESPONSIBLE TEAM: team-ai-agent */
import Model, { attr } from '@ember-data/model';

export default class PreviewSettings extends Model {
  @attr('string') declare previewAddress: string;
}
